<div class="switch-container" (click)="toggleSwitch()">
  <div class="switch-option" [class.active]="activeOption === 1">
    Пропозиції
  </div>
  <div class="switch-option" [class.active]="activeOption === 2">
    Запити
  </div>
</div>
